"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SeeAllSkeleton = exports.SectionLabelSkeleton = void 0;
var _mui = require("@ori-ui/mui");
var _presentationUtils = require("@ori/presentation-utils");
var _styles = require("../SearchPreview/styles");
var _styles2 = require("../styles");
var _constants = require("./constants");
const SeeAllSkeleton = exports.SeeAllSkeleton = (0, _mui.styled)(_styles.SeeAllResults)({
  height: _presentationUtils.SEARCH_PREVIEW_SEE_ALL_HEIGHT
});
const SectionLabelSkeleton = exports.SectionLabelSkeleton = (0, _mui.styled)(_styles2.UnifiedSkeleton)({
  height: _constants.SECTION_LABEL_HEIGHT,
  width: _constants.SECTION_LABEL_WIDTH
});
